import { useRef, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
// import Logo from '../../assets/logo-text2.png';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { Input, InputGroup } from '../../components/unform/index';
import { Spinner } from '../../components/index';
import { useAuth } from '../../contexts/auth';
import { useValidator } from '../../hooks/index';
import login from '../../assets/svg/login.svg';

export default function Login() {
  const { signIn } = useAuth();
  const { validator, toast } = useValidator();
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (data) => {
    const { errors, hasError } = validator(data);
    formRef.current.setErrors(errors);
    if (hasError) {
      return toast();
    }
    setLoading(true);
    try {
      await signIn(data);
    } catch (err) {
      toast(err.mensagem || err.message);
      setLoading(false);
    }
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Row className="vh-100 m-0 bg-gray">
      <Col
        className="h-100 d-none d-lg-flex align-items-center p-5"
        lg={8}
        sm={12}
      >
        <div className="h-100 w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img className="img-login" src={login} alt="Login V2" />
        </div>
      </Col>
      <Col
        className="d-flex align-items-center auth-bg px-2 p-lg-5 bg-white-theme"
        lg={4}
        sm={12}
      >
        <Col className="px-xl-4 mx-auto" sm={8} md={6} lg={12}>
          <h3 className="font-weight-bold mb-1 card-title">
            Bem vindo de volta! 👋
          </h3>
          <p className="mb-4 card-text">
            Por favor faça o login para prosseguir
          </p>

          <Form onSubmit={(data) => handleSubmit(data)} ref={formRef}>
            <Input
              name="email"
              label="Email"
              className="form-control"
              placeholder="Seu email"
            />
            <InputGroup
              name="senha"
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              className="form-control-group"
              placeholder="* * * * *"
              append={
                <Button size="sm" color="link" onClick={toggleShowPassword}>
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </Button>
              }
            />
            <div className="d-flex justify-content-end mb-3">
              {/* <CheckBox name="persistir" label="Manter conectado ?" /> */}
              <Link to="/esqueci-minha-senha" className="pt-1">
                Esqueceu a senha ?
              </Link>
            </div>

            <Button color="primary" className="btn-block" disabled={loading}>
              {loading ? <Spinner /> : 'Login'}
            </Button>

            <p className="text-center mt-4">
              <span className="mr-25">Novo na plataforma ? </span>
              <Link to="/cadastro">
                <span>Criar conta</span>
              </Link>
            </p>
          </Form>
        </Col>
      </Col>
    </Row>
  );
}
